module.exports = __webpack_public_path__ + "img/9788967355388.01e3a6e8.jpg";